/**
 * 店舗の詳細ページのルートコンポーネント、組織ごとにコピーして拡張
 *
 * テンプレートはJinjaの以下と紐づく
 * templates/organizations/{...}/point.html > templates/default/point.html
 *
 * 特にカスタマイズが不要なら複製は不要
 */
import { defineComponent, computed, ref, onMounted } from 'vue'
import PointPage from "@/organizations/_default/point"
import ImageSlider from "./ImageSliderSne.vue"
import { overrideFetchPointsByGeohash, overrideHeaderStyle } from './overrides'

export default defineComponent({
  extends: PointPage,
  components: { ImageSlider },
  setup(props, context) {
    overrideFetchPointsByGeohash()

    const page = PointPage.setup(props, context)
    const point = storelocator.point.point
    const isInternal = ref(storelocator.path.id == "internal")

    // スライダー用画像
    const images = computed(() => {
      const _images = [
        { url: point.extra_fields["写真１"], bottomText: point.extra_fields["写真キャプション１"]},
        { url: point.extra_fields["写真２"], bottomText: point.extra_fields["写真キャプション２"]},
        { url: point.extra_fields["写真３"], bottomText: point.extra_fields["写真キャプション３"]},
        { url: point.extra_fields["写真４"], bottomText: point.extra_fields["写真キャプション４"]},
        { url: point.extra_fields["写真５"], bottomText: point.extra_fields["写真キャプション５"]},
        { url: point.extra_fields["写真６"], bottomText: point.extra_fields["写真キャプション６"]},
      ]

      return _images.filter((img) => {
        if (img.url) {
          return true
        }
        return false
      })
    })

    // 納入製品まとめ
    const product = computed(() => {
      const product_detail_indexes = ["", "2", "3", "4", "5", "6"]
      const product_detail = product_detail_indexes.map((idx) => {
        return {
          kind: point.extra_fields[`品種名${idx}`] ?? "",
          type: point.extra_fields[`タイプ${idx}`] ?? "",
          material: point.extra_fields[`材質${idx}`] ?? "",
          surface: point.extra_fields[`表面処理${idx}`] ?? "",
          description: point.extra_fields[`備考${idx}`] ?? ""
        }
      }).filter((detail) => {
        const values = Object.values(detail)
        return !values.every((v) => v == "")
      })
      return product_detail
    })

    // 社内 / 社外共有属性まとめ
    const showAttributeKeys = [
      {key: "施主", label: "施主"},
      {key: "施工年月", label: "施工年月"},
      {key: "address", label: "施工場所"},
    ]

    const attributes = ref(showAttributeKeys.map(attr => {
      let value = null
      if (point[attr.key]) {
        value = point[attr.key]
      } else {
        value = point.extra_fields[attr.key] ?? ""
      }

      if (attr.key == "施工年月" && value) {
        const constructDate = value.split("/")
        if (isInternal.value) {
          value = `${constructDate[0]}年${constructDate[1]}月`
        } else {
          value = `${constructDate[0]}年`
        }
      }

      return {
        label: attr.label,
        value: value
      }
    }))

    // 社内向け属性まとめ
    const showInternalAttributeKeys = [
      {key: "引合件名", label: "引合件名"},
      {key: "引合№", label: "引合い番号"},
      {key: "品種ブランド名", label: "ブランド"},
      {key: "営業担当者", label: "担当者"},
      {key: "売上額", label: "売上金額"},
      {key: "設計コンサルタント", label: "設計コンサルタント"},
    ]

    const internalAttributes = ref(showInternalAttributeKeys.map(attr => {
      let value = point.extra_fields[attr.key] ?? ""

      // 要望は「★」表示ではあるものの、要件定義で「表示したい文字列を入力し画面には出すだけ」となった
      // （変更の備えてコメントアウト）
      // if (attr.key == "売上額" && value) {
      //   value = "★".repeat(value)
      // }

      return {
        label: attr.label,
        value: value
      }
    }))

    // 管理番号 社内、社外2つ設定されている場合は併記
    let managementNumber = point.key
    if (isInternal.value) {
      const internalKey = point.extra_fields["社内管理番号"] ?? ""
      if (internalKey && managementNumber != internalKey) {
        managementNumber = `${managementNumber} / ${internalKey}`
      }
    }

    // 検索ワードに表示する内容をまとめる
    // 使用場所から検索と製品種類検索キーの組み合わせ
    const productSearchKey = point.extra_fields['製品種類検索キー'] ?? []
    const productPlace = point.extra_fields['使用場所から検索'] ?? []
    let productSearchWords = [
      ...productSearchKey.split(","),
      ...productPlace.split(",")
    ].filter(word => word != '')

    // Setを利用して重複を排除
    productSearchWords = new Set(productSearchWords)
    const searchWords = ref([...productSearchWords])

    onMounted(() => {
      overrideHeaderStyle(isInternal.value)
    })

    return {
      ...page,
      isInternal,
      managementNumber,
      images,
      product,
      attributes,
      internalAttributes,
      searchWords
    }
  }
})